export enum TipoDocumentoAdjuntoEnum {
    SOLICITUD_AFILIACION= 'SOLICITUD_AFILIACION',
    PODER_CUENTA_TERCERO= 'PODER_CUENTA_TERCERO',
    FOTOGRAFIA_CEDULA= 'FOTOGRAFIA_CEDULA',
    PATENTE_COMERCIAL= 'PATENTE_COMERCIAL',
    BOLETA_O_FACTURA= 'BOLETA_O_FACTURA',
    ESCRITURA= 'ESCRITURA',
    FERIAS_Y_EVENTOS= 'FERIAS_Y_EVENTOS',
    FOTOGRAFIAS_LOCAL= 'FOTOGRAFIAS_LOCAL',
    CERTIFICADO_COMPLIANCE= 'CERTIFICADO_COMPLIANCE'
}
